export function formatPhone(phone: string | undefined | null): string {
  if (!phone) {
    return '';
  }
  // Simple formatting: (123) 456-7890
  if (phone.startsWith('+1')) {
    phone = phone.slice(2);
  }
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return phone;
}

export function prefixPhone(phone: string | undefined | null): string {
  if (!phone) {
    return '';
  }
  // Ensure phone number has country code +1
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `+1${digits}`;
  } else if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }
  return phone; // Return as is if it doesn't match expected lengths
}
